export const ModuleIdMappingQa = {
  PUBLIC_MODULE_ID: 'PUBLIC_MODULE_ID',
  UPLOAD_PRICING_ID: 'f0c1b30d-9c59-452e-a5cd-930015afdef0',
  PRICING_SUMMARY_ID: 'f04758bf-b17e-4284-88d7-a006e49531c9',
  APPROVALS_ID: '296f63af-a41f-4c9b-88c9-35e352fa673b',
  BULK_PO_CREATION: '6758319f-ce3a-481d-902a-ed18ed5cf6ac',
  PO_SUMMARY_ID: 'b799d783-ed27-4d69-8844-4fea7dc99994',
  ASN_ID: 'c28bce0a-fa59-4142-b84a-1b4707e418e8',
  PO_MANAGEMENT_ID: '9f98d150-e8b5-4a87-a0ff-eec07dc1ce20',
  SKU_PRICE_SUGGESTIONS_ID: '939c4bd6-75ac-4322-8e3b-04cd22bbcb21',
  BUNDLE_PRICE_SUGGESTIONS_ID: '1f8d89f3-65db-400e-ac26-c26e747461db',
  SKU_ID: '0ea3bea3-932c-47f3-a561-0503a8fe8711',
  BUNDLE_LIVE_PRICING_ID: 'fd697579-1264-496f-8a54-9d924f7f11d4',
  USER_MANAGEMENT_ID: '87b850be-57dd-49c9-affb-225a5a174b33',
  REPORTS_ID: '667b6648-fbce-4645-90ea-679c839ab808',
  ENTITY_MANAGEMENT: '9dcd74f2-64d1-4ef0-8aa0-275d1d8678d8',
  PRICING_ID: 'b46f73e6-7a57-4e08-b09c-51f6384a1eeb',
  SKU_LIVE_PRICING_ID: 'd5a0f080-16ab-4110-8e4d-b54de6060780',
  BULK_JOBS_ID: '395f8076-3bf7-4975-8450-de7e976a9f5e',
  PO_REPORTS_ID: '1ad648e7-37ae-4a7e-9089-ad043a36edcb',
  PO_APPROVALS_ID: '9d0c17c8-ad63-4c23-92eb-aa5311c297b8',
  RETURN_PO_ACKNOWLEDGEMENT_ID: 'd9cedee2-f3f9-40ff-9dba-187537a2c59b',
};
